import React from 'react';
import { Mail } from 'lucide-react';

const SignupHeader: React.FC = () => (
  <div className="mb-12">
    <Mail className="w-16 h-16 text-blue-600 mx-auto mb-6" />
    <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
      Be First to Know
    </h2>
    <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto">
      Get notified when our Roommaster to Xero integration launches. 
      Plus, early subscribers get exclusive pricing and priority support.
    </p>
  </div>
);

export default SignupHeader;